export enum Breakpoints {
  DESKTOP = '992px',
  TABLET = '768px',
  MOBILE = '576px',
  LARGE_DESKTOP = '1200px',
}
